import { render, staticRenderFns } from "./HowToGetBook.vue?vue&type=template&id=264fb4c9"
import script from "./HowToGetBook.vue?vue&type=script&lang=js"
export * from "./HowToGetBook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports